// Test server only: ?preview=update,sync-sent,sync-failing shows top bar states that a dev setup
// cannot reach (no installed release, sending blocked). A release build strips this (NODE_ENV is
// 'production' there), so it can never change what the site laptops show.
const fromUrl = new URLSearchParams(window.location.search).get('preview');
if (fromUrl !== null) { try { sessionStorage.setItem('devPreview', fromUrl); } catch { /* storage blocked */ } }

const devPreview = (name) => {
    if (process.env.NODE_ENV !== 'development') return false;
    let value = fromUrl;
    try { value = value ?? sessionStorage.getItem('devPreview'); } catch { /* storage blocked */ }
    return String(value ?? '').split(',').map((s) => s.trim()).includes(name);
};

export default devPreview;
